export default class Dienstort {

    public dienstort_id: number | null = null;
    public dienstort: string | null = null;
    public dienstort_langtext: string | null = null;
    public parent_dienstort_id: number | null = null;
    public parent_dienstort_id_dienstort: string | null = null;

    constructor(data?: Partial<Dienstort>) {
        Object.assign(this, data);
    }
}
